import { render, staticRenderFns } from "./details-drawer.vue?vue&type=template&id=4bd9e411&scoped=true"
import script from "./details-drawer.vue?vue&type=script&lang=js"
export * from "./details-drawer.vue?vue&type=script&lang=js"
import style0 from "./details-drawer.vue?vue&type=style&index=0&id=4bd9e411&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bd9e411",
  null
  
)

export default component.exports